export default __webpack_public_path__ + "static/162-4ab3143bf74b7c74a08554a75656d42b.jpg";